import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { saveEditedUserBillTosCollection } from "@NA/Services/ADIUserAdminSuffixInfosService";
import { AccountBillToCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { PatchAccountBillToCollectionApiParameter } from "@insite/client-framework/Types/ApiModels";
import { HasOnError, HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type HandlerType = CustomApiHandler<
    PatchAccountBillToCollectionApiParameter & HasOnSuccess & HasOnError,
    ServiceResult<AccountBillToCollectionModel>
>;

export const submitData: HandlerType = async props => {
    try {
        props.apiResult = await saveEditedUserBillTosCollection(props.parameter);
    } catch (error) {
        props.apiResult = (error as any)?.errorMessage || "Unknown error";
    }
};

export const chain = [submitData];

const submitEditedData = createHandlerChainRunner(chain, "ADIUserAdminSaveEditedDataHandler");
export default submitEditedData;
